import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Button from '@omilia/button';

import {
  SIconImage,
  SErrorInfoContainer,
  SErrorH1,
  SErrorSubtitle,
  FixStyle,
} from 'components/styled';

import ErrorLayout from 'components/ErrorLayout';

const NotFound = () => (
  <ErrorLayout>
    <Helmet>
      <title>Not found</title>
    </Helmet>

    <SIconImage glyph="error-404" size="96" />

    <SErrorInfoContainer>
      <SErrorH1>Oops, error!</SErrorH1>
      <SErrorSubtitle level={1}>
        Sorry, the page you are looking for does not exits or has been moved
      </SErrorSubtitle>
    </SErrorInfoContainer>

    <Link to="/">
      <FixStyle />
      <Button color="primary" variant="contained">
        Return back
      </Button>
    </Link>
  </ErrorLayout>
);

export default NotFound;
